import { getAccountOrgMembershipDef } from '../../../../backend/features/accounts/shared';
import { useDataTableUsingUrl, } from '@juvare/common-data-table-ui/DataTable';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
function useGetAccountMembership(request, accountId) {
    var _a, _b;
    const { data, isLoading, error, mutate } = useTypedPlatformFunctionResponse(getAccountOrgMembershipDef, Object.assign({ accountId }, request));
    return {
        data: data ? { rows: (_a = data.items) !== null && _a !== void 0 ? _a : [], filteredRowCount: (_b = data.total) !== null && _b !== void 0 ? _b : 0 } : undefined,
        error,
        reload: mutate,
        isLoading: isLoading,
        customBackendResponseData: {
            orgStatus: data === null || data === void 0 ? void 0 : data.orgStatus,
            orgRole: data === null || data === void 0 ? void 0 : data.orgRole,
            memberFullName: data === null || data === void 0 ? void 0 : data.memberFullName,
        },
    };
}
export function useAccountOrgMembershipTable({ accountId, userCanDoBulkActions, }) {
    const dataTableParams = {
        useDataProvider: (request) => useGetAccountMembership(request, accountId),
        rowSelectionEnabled: userCanDoBulkActions,
        defaultSortColumnKey: 'name',
        onRowClick: undefined,
        defaultRowsPerPage: 100,
    };
    const result = useDataTableUsingUrl(dataTableParams);
    return Object.assign(Object.assign({}, result), { dataTableProps: Object.assign(Object.assign({}, result.dataTableProps), { filtersBar: undefined, columns: [], filteredRowCount: result.dataTableProps.filteredRowCount }) });
}
